// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"f08ab330","585":"d5e22168","948":"f08ab330"}[chunkId] + ".chunk.css";
};